<template>
  <div class="container">
    <div class="container-hide" v-if="unsp_file"></div>
    <div id="overlay-body"></div>

    <div class="row pt-3">
      <div class="col-lg-4 offset-lg-4">
        <img class="logo" src="../assets/images/fusion-logo.svg" />
      </div>
    </div>

    <div class="row main">
      <div class="col-lg-5 col-md-5">
        <form
          id="form"
          rel="form"
          action=""
          method="POST"
          v-on:mouseover="mouseover"
          v-on:mouseleave="mouseleave"
        >
          <div id="overlay"></div>
          <input
            id="file-upload"
            type="file"
            multiple="multiple"
            @change="fileValidation"
          />
          <p v-if="formpSeen">
            drop CSS <small>&</small> HTML <span> here</span>
          </p>
          <p v-if="addNextFile">Add another one</p>
          <div class="col-md-8 text-center" id="img-upload-filename"></div>
          <div class="col-md-12 text-center" id="download-fuse-trigger-holder">
            <button
              class="download"
              v-if="showDownloadButton"
              v-on:click="downloadFusedFiles"
            >
              Download <i class="fas fa-angle-down"></i>
            </button>
          </div>
        </form>
        <div class="row">
          <div class="col-md-8 text-center" id="file-upload-filename">
            <div v-for="file in files">
              <p>
                {{ file.name }}
                <span class="spanDelete" v-on:click="removeFile(file)">{{
                  span
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-md-7 right">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="code_editor" id="editor-html"></div>
          </div>
          <div class="col-lg-12 col-md-12">
            <h2 class="hiddenHead" v-if="unsp_file">This file is unsuported</h2>
          </div>

          <div class="col-lg-12 col-md-12">
            <div class="code_editor" id="editor-css"></div>
          </div>
          <div class="col-lg-12 col-md-12">
            <button
              class="float-right fuse"
              v-on:click="fuse"
              src="../assets/images/fuse-button.svg"
            >
              fuse <span>/></span>
            </button>
          </div>
          <!-- <div class="col-lg-12 col-md-12 mt-5">
            <img class="float-right" src="../assets/images/git-logo.svg" />
          </div> -->
        </div>
      </div>
    </div>
    <div
      class="modal"
      v-bind:class="{
        in: showFusedContentModal,
        'remove-modal-display-none': showFusedContentModal
      }"
      id="fused-content-modal"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4
              class="modal-title"
              v-on:click="copyFusedContent"
              style="font-weight: bold;"
            >
              {{ copyContent }}
              <span id="span_top" style="color: #ffb33c">/></span>
            </h4>
            <button
              type="button"
              class="close"
              v-on:click="closeFusedContentModal"
              data-dismiss="modal"
            >
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="code_editor_modal" id="fused-content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let ace = require("ace-builds");
let aceMonokaiTheme = require("ace-builds/src-noconflict/theme-monokai");
let aceModeHtml = require("ace-builds/src-noconflict/mode-html").Mode;
let aceModeCss = require("ace-builds/src-noconflict/mode-css").Mode;
let cssFuser = require("@gsix-oven/css-fusion");

ace.config.set("basePath", "ace-builds/src-noconflict");

let editorHtml;
let editorCss;
let inputFiles;

export default {
  name: "CssFusion",
  props: {
    msg: String
  },
  data() {
    return {
      formpSeen: true,
      showDownloadButton: false,
      fusedContent: "",
      fileCssContent: "",
      fileHtmlContent: "",
      filesReadCompleted: 0,
      copyContent: "copy",
      files: [],
      showFusedContentModal: false,
      unsp_file: false,
      span: "X",
      addNextFile: false
    };
  },
  methods: {
    fuse: function(event) {
      event.preventDefault();

      this.fusedContent = cssFuser(
        editorCss.session.getValue(),
        editorHtml.session.getValue()
      );

      this.showFusedContentModal = true;

      let editorModal = ace.edit("fused-content");
      editorModal.setTheme(aceMonokaiTheme);
      editorModal.session.setMode(new aceModeHtml());
      editorModal.session.setUseWorker(false);
      document.getElementById("fused-content").style.fontSize = "24px";
      editorModal.setValue(this.fusedContent.trim());
      editorModal.setHighlightActiveLine(false);
      editorModal.clearSelection();
      editorModal.session.setUseWrapMode(true);
      document.getElementById("overlay-body").style.display = "block";
      document.getElementById("span_top").style.color = "white";
    },
    closeFusedContentModal: function(event) {
      let clickedModal = document.querySelector(".modal-header");
      event.preventDefault();
      this.showFusedContentModal = false;
      document.getElementById("overlay-body").style.display = "none";
      this.copyContent = "copy";
      clickedModal.classList.remove("modal-header-cliked");
    },
    copyFusedContent: function(event) {
      let clickedModal = document.querySelector(".modal-header");
      event.preventDefault();
      this.copyToClipboard(this.fusedContent.trim());
      clickedModal.classList.add("modal-header-cliked");
      this.copyContent = "copied!";
    },
    copyToClipboard(string) {
      const el = document.createElement("textarea");
      el.value = string;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    downloadFusedFiles: function(event) {
      event.preventDefault();
      this.filesReadCompleted = 0;
      this.fileCssContent = "";
      this.fileHtmlContent = "";

      Array.from(this.files).forEach(file => {
        if (this.extractFileExtension(file.name) === "css") {
          let reader = new FileReader();
          reader.readAsText(file, "UTF-8");

          reader.onload = evt => {
            this.fileCssContent += evt.target.result;
            this.filesReadCompleted++;
            this.fuseFilesAndDownloadResult();
          };
        }

        if (this.extractFileExtension(file.name) === "html") {
          let reader = new FileReader();
          reader.readAsText(file, "UTF-8");

          reader.onload = evt => {
            this.fileHtmlContent += evt.target.result;
            this.filesReadCompleted++;
            this.fuseFilesAndDownloadResult();
          };
        }
      });
    },
    extractFileExtension: function(fileName) {
      return fileName.split(".").pop();
    },
    fuseFilesAndDownloadResult: function() {
      if (this.files.length !== this.filesReadCompleted) {
        return false;
      }

      const fusedContent = cssFuser(this.fileCssContent, this.fileHtmlContent);

      let hiddenElement = document.createElement("a");

      hiddenElement.href =
        "data:text/plain;charset=utf-8," + encodeURIComponent(fusedContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "fuse.html";
      hiddenElement.click();
    },

    fileValidation: function() {
      let fileInput = document.getElementById("file-upload");
      let filePath = fileInput.value;
      let allowedExtensions = /(\.css|\.html)$/i;
      let form = document.getElementById("form");
      if (!allowedExtensions.exec(filePath)) {
        fileInput.value = "";
        this.showDownloadButton = false;
        form.style.backgroundSize = "100px";
        form.style.backgroundPosition = "50% 38%";
        this.unsp_file = true;
        setTimeout(() => (this.unsp_file = false), 1800);
        return false;
      }
    },

    mouseover: function() {
      let form = document.getElementById("form");
      form.style.border = "8px dashed #ffb33c";
    },
    mouseleave: function() {
      let form = document.getElementById("form");
      form.style.border = "4px dashed white";
    },

    removeFile: function(file) {
      let form = document.getElementById("form");
      this.files.splice(this.files.indexOf(file), 1);
      if (this.files.length === 0) {
        this.formpSeen = true;
        form.style.backgroundSize = "100px";
        this.showDownloadButton = false;
        this.addNextFile = false;
      }
    }
  },
  mounted() {
    inputFiles = document.getElementById("file-upload");
    let infoArea = document.getElementById("file-upload-filename");
    let form = document.getElementById("form");

    inputFiles.addEventListener("change", event => {
      let inputFiles = event.srcElement;
      let form = document.getElementById("form");

      if (inputFiles.files.length >= 1) {
        this.showDownloadButton = true;
        this.formpSeen = false;
        form.style.backgroundSize = "0px";
        infoArea.style.color = "white";
        infoArea.style.fontSize = "20px";
        this.addNextFile = true;
        form.style.backgroundPosition = "50% 38%";
        form.style.border = "4px solid white";
      }

      this.filesReadCompleted = 0;

      Array.from(inputFiles.files).forEach(file => {
        // infoArea.innerHTML += "<div>" + '<p style = "display: inline;">' + file.name  + '</p>' +  '<span id="spanDelete" @click="removeFile($index)">' + this.span + '</span>' + "</div>" ;
        this.files.push(file);
      });
    });

    const followMouse = () => {
      let fullscreenform = document.querySelector(".fullscreenform");
      document.addEventListener(
        "dragover",
        function(e) {
          e = e || window.event;
          let dragX = e.pageX,
            dragY = e.pageY;
          fullscreenform.style.backgroundPosition =
            dragX - 150 + "px " + (dragY - 120) + "px";
        },
        false
      );
    };

    inputFiles.addEventListener("dragenter", () => {
      this.formpSeen = true;
      form.classList.add("fullscreenform");
      document.getElementById("overlay").style.display = "block";
      this.showDownloadButton = false;
      followMouse();
    });

    inputFiles.addEventListener("dragleave", () => {
      form.classList.remove("fullscreenform");
      document.getElementById("overlay").style.display = "none";
      this.showDownloadButton = false;
      form.style.backgroundPosition = "50% 38%";
    });

    inputFiles.addEventListener("drop", () => {
      this.formpSeen = false;
      this.showDownloadButton = true;
      form.style.backgroundSize = "0px";
      form.classList.remove("fullscreenform");
      infoArea.style.fontSize = "20px";
      infoArea.style.color = "white";
      document.getElementById("overlay").style.display = "none";
      form.style.border = "4px solid #FFF";
    });

    editorHtml = ace.edit("editor-html");
    editorHtml.setTheme(aceMonokaiTheme);
    editorHtml.session.setMode(new aceModeHtml());
    editorHtml.session.setUseWorker(false);
    document.getElementById("editor-html").style.fontSize = "18px";
    editorHtml.setHighlightActiveLine(false);
    editorHtml.setValue(`
<div>
  <h1>This is a heading</h1>
  <p>This is a paragraph</p>
</div>
`);
    editorHtml.session.setUseWrapMode(true);
    editorHtml.clearSelection();

    editorCss = ace.edit("editor-css");
    editorCss.setTheme(aceMonokaiTheme);
    editorCss.session.setMode(new aceModeCss());
    editorCss.session.setUseWorker(false);
    document.getElementById("editor-css").style.fontSize = "18px";
    editorCss.setHighlightActiveLine(false);
    editorCss.setValue(`
div{
  background-color: blue;
}

h1{
  font-size: 33px;
  font-weight: bold;
}

p{
  color: #FFC600;
}
`);
    editorCss.session.setUseWrapMode(true);
    editorCss.clearSelection();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#download-fuse-trigger-holder {
  position: absolute;
  bottom: 38%;
  left: 0;
}

.remove-modal-display-none {
  display: block;
}
</style>
